import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.8 2.6001C20.8 2.04781 20.3523 1.6001 19.8 1.6001C19.2478 1.6001 18.8 2.04781 18.8 2.6001V4.66806C17.0163 3.01305 14.6268 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C16.1022 22 19.6253 19.5301 21.1675 16.0004C21.3886 15.4943 21.1576 14.9048 20.6515 14.6836C20.1454 14.4625 19.5559 14.6935 19.3348 15.1996C18.0994 18.0272 15.279 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C14.2871 4 16.3509 4.95948 17.8098 6.5001H14.8C14.2478 6.5001 13.8 6.94781 13.8 7.5001C13.8 8.05238 14.2478 8.5001 14.8 8.5001H19.7852C19.7964 8.50023 19.8077 8.50017 19.8189 8.49992C20.3625 8.48987 20.8 8.04608 20.8 7.5001V2.6001Z"
  }));
});
var ActionsRedo = AbstractIcon.withComponent(Icon);
ActionsRedo.displayName = 'ActionsRedo';
export default ActionsRedo;